// Automatically generated with Reach 0.1.3
/* eslint-disable */
export const _version = '0.1.3';
export const _backendVersion = 1;


export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };

export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  
  return {
    infos: {
      },
    views: {
      }
    };
  
  };

export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };

export async function Alice(ctc, interact) {
  if (typeof(ctc) !== 'object' || ctc.sendrecv === undefined) {
    return Promise.reject(new Error(`The backend for Alice expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Alice expects to receive an interact object as its second argument.`));}
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_UInt;
  const ctc1 = stdlib.T_Tuple([ctc0]);
  const ctc2 = stdlib.T_Digest;
  
  
  
  const v15 = stdlib.protect(ctc0, interact.amt, 'for Alice\'s interact field amt');
  const v16 = stdlib.protect(ctc0, interact.pass, 'for Alice\'s interact field pass');
  
  const v20 = stdlib.digest(ctc1, [v16]);
  
  const txn1 = await (ctc.sendrecv({
    args: [v20, v15],
    evt_cnt: 2,
    funcNum: 1,
    onlyIf: true,
    out_tys: [ctc2, ctc0],
    pay: [v15, []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const [v22, v23] = txn1.data;
      const v26 = txn1.time;
      const v27 = txn1.secs;
      const v21 = txn1.from;
      
      sim_r.txns.push({
        amt: v23,
        kind: 'to',
        tok: undefined
        });
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc2, ctc0],
    waitIfNotPresent: false
    }));
  const [v22, v23] = txn1.data;
  const v26 = txn1.time;
  const v27 = txn1.secs;
  const v21 = txn1.from;
  ;
  const txn2 = await (ctc.recv({
    evt_cnt: 1,
    funcNum: 2,
    out_tys: [ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const [v35] = txn2.data;
  const v37 = txn2.time;
  const v38 = txn2.secs;
  const v34 = txn2.from;
  ;
  const v39 = stdlib.digest(ctc1, [v35]);
  const v40 = stdlib.digestEq(v22, v39);
  stdlib.assert(v40, {
    at: './index.rsh:75:12:application',
    fs: [],
    msg: 'Digests actually match',
    who: 'Alice'
    });
  ;
  return;
  
  
  };
export async function Bob(ctc, interact) {
  if (typeof(ctc) !== 'object' || ctc.sendrecv === undefined) {
    return Promise.reject(new Error(`The backend for Bob expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bob expects to receive an interact object as its second argument.`));}
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Digest;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Tuple([ctc1]);
  
  
  
  const txn1 = await (ctc.recv({
    evt_cnt: 2,
    funcNum: 1,
    out_tys: [ctc0, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const [v22, v23] = txn1.data;
  const v26 = txn1.time;
  const v27 = txn1.secs;
  const v21 = txn1.from;
  ;
  const v31 = stdlib.protect(ctc1, await interact.getPass(), {
    at: './index.rsh:61:47:application',
    fs: ['at ./index.rsh:60:13:application call to [unknown function] (defined at: ./index.rsh:60:17:function exp)'],
    msg: 'getPass',
    who: 'Bob'
    });
  const v32 = stdlib.digest(ctc2, [v31]);
  const v33 = stdlib.digestEq(v22, v32);
  stdlib.assert(v33, {
    at: './index.rsh:62:13:application',
    fs: ['at ./index.rsh:60:13:application call to [unknown function] (defined at: ./index.rsh:60:17:function exp)'],
    msg: null,
    who: 'Bob'
    });
  
  const txn2 = await (ctc.sendrecv({
    args: [v22, v23, v31],
    evt_cnt: 1,
    funcNum: 2,
    onlyIf: true,
    out_tys: [ctc1],
    pay: [stdlib.checkedBigNumberify('./index.rsh:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const [v35] = txn2.data;
      const v37 = txn2.time;
      const v38 = txn2.secs;
      const v34 = txn2.from;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v39 = stdlib.digest(ctc2, [v35]);
      const v40 = stdlib.digestEq(v22, v39);
      stdlib.assert(v40, {
        at: './index.rsh:75:12:application',
        fs: [],
        msg: 'Digests actually match',
        who: 'Bob'
        });
      sim_r.txns.push({
        amt: v23,
        kind: 'from',
        to: v34,
        tok: undefined
        });
      sim_r.txns.push({
        kind: 'halt',
        tok: undefined
        })
      sim_r.isHalt = true;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc1, ctc1],
    waitIfNotPresent: false
    }));
  const [v35] = txn2.data;
  const v37 = txn2.time;
  const v38 = txn2.secs;
  const v34 = txn2.from;
  ;
  const v39 = stdlib.digest(ctc2, [v35]);
  const v40 = stdlib.digestEq(v22, v39);
  stdlib.assert(v40, {
    at: './index.rsh:75:12:application',
    fs: [],
    msg: 'Digests actually match',
    who: 'Bob'
    });
  ;
  return;
  
  
  };

const _ALGO = {
  appApproval: `#pragma version 4
txn RekeyTo
global ZeroAddress
==
assert
txn Lease
global ZeroAddress
==
assert
int 0
store 0
txn ApplicationID
bz alloc
byte base64()
app_global_get
dup
substring 0 32
store 1
substring 32 64
store 2
txn NumAppArgs
int 3
==
assert
txna ApplicationArgs 0
btoi
dup
bz ctor
// Handler 1
dup
int 1
==
bz l0
pop
txna ApplicationArgs 1
dup
len
int 0
==
assert
pop
txna ApplicationArgs 2
dup
len
int 40
==
assert
dup
substring 0 32
store 255
dup
substring 32 40
btoi
store 254
pop
// compute state in HM_Check 0
int 8
bzero
sha256
load 1
==
assert
// "CheckPay"
// "./index.rsh:51:11:dot"
// "[]"
load 254
dup
bz l1
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
load 2
dig 1
gtxns Receiver
==
assert
l1:
pop
// compute state in HM_Set 1
byte base64(AAAAAAAAAAE=)
load 255
concat
load 254
itob
concat
sha256
store 1
txn OnCompletion
int NoOp
==
assert
b updateState
l0:
// Handler 2
dup
int 2
==
bz l2
pop
txna ApplicationArgs 1
dup
len
int 40
==
assert
dup
substring 0 32
store 255
dup
substring 32 40
btoi
store 254
pop
txna ApplicationArgs 2
dup
len
int 8
==
assert
dup
btoi
store 253
pop
// compute state in HM_Check 1
byte base64(AAAAAAAAAAE=)
load 255
concat
load 254
itob
concat
sha256
load 1
==
assert
// "CheckPay"
// "./index.rsh:64:9:dot"
// "[]"
// Just "Digests actually match"
// "./index.rsh:75:12:application"
// "[]"
load 255
load 253
itob
sha256
==
assert
load 254
dup
bz l3
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
load 2
dig 1
gtxns Sender
==
assert
txn Sender
dig 1
gtxns Receiver
==
assert
l3:
pop
int 0
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
load 2
dig 1
gtxns Sender
==
assert
global CreatorAddress
dig 1
gtxns CloseRemainderTo
==
assert
l4:
pop
global ZeroAddress
store 1
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l2:
int 0
assert
updateState:
byte base64()
load 1
load 2
concat
app_global_put
checkSize:
load 0
dup
dup
int 1
+
global GroupSize
==
assert
txn GroupIndex
==
assert
int 1000
*
txn Fee
<=
assert
done:
int 1
return
alloc:
txn OnCompletion
int NoOp
==
assert
byte base64()
int 64
bzero
app_global_put
b checkSize
ctor:
txn Sender
global CreatorAddress
==
assert
txna ApplicationArgs 1
store 2
// compute state in HM_Set 0
int 8
bzero
sha256
store 1
txn OnCompletion
int NoOp
==
assert
b updateState
`,
  appClear: `#pragma version 4
int 0
`,
  escrow: `#pragma version 4
global GroupSize
int 1
-
dup
gtxns TypeEnum
int appl
==
assert
gtxns ApplicationID
int {{ApplicationID}}
==
assert
done:
int 1
`,
  mapDataKeys: 0,
  mapDataSize: 0,
  unsupported: [],
  version: 2,
  viewKeys: 0,
  viewSize: 0
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "bool",
            "name": "svs",
            "type": "bool"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "v22",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v23",
                "type": "uint256"
              }
            ],
            "internalType": "struct T0",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T2",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [],
    "name": "e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "bool",
            "name": "svs",
            "type": "bool"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "v22",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v23",
                "type": "uint256"
              }
            ],
            "internalType": "struct T0",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T2",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "v22",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v23",
                "type": "uint256"
              }
            ],
            "internalType": "struct T0",
            "name": "svs",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "v35",
                "type": "uint256"
              }
            ],
            "internalType": "struct T3",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T4",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "e2",
    "type": "event"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "v22",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v23",
                "type": "uint256"
              }
            ],
            "internalType": "struct T0",
            "name": "svs",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "v35",
                "type": "uint256"
              }
            ],
            "internalType": "struct T3",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T4",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "m2",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `0x60806040526040516103db3803806103db8339810160408190526100229161012c565b6040517f49ff028a829527a47ec6839c7147b484eccf5a2a94853eddac09cef44d9d4e9e90600090a16040805182511515815260208084015180518284015201518183015290517f3c669845d6bbc6fc367c9fa11ea5c8ec9bfd3d70eae7b34375b93f114f7403659181900360600190a160208082015101516100a89034146007610103565b60408051808201909152600080825260208201526020808301805151835251810151828201526040516100e091600191849101610194565b60408051601f198184030181529190528051602090910120600055506101ef9050565b816101285760405163100960cb60e01b81526004810182905260240160405180910390fd5b5050565b6000818303606081121561013f57600080fd5b6101476101b9565b8351801515811461015757600080fd5b81526040601f198301121561016b57600080fd5b6101736101b9565b60208581015182526040909501518582015293810193909352509092915050565b828152606081016101b2602083018480518252602090810151910152565b9392505050565b604080519081016001600160401b03811182821017156101e957634e487b7160e01b600052604160045260246000fd5b60405290565b6101dd806101fe6000396000f3fe6080604052600436106100225760003560e01c8063212df9891461002e57600080fd5b3661002957005b600080fd5b61004161003c36600461016a565b610043565b005b60405161007f9061005b906001908490602001610182565b6040516020818303038152906040528051906020012060001c60005414600a610141565b60008055604080518235815260208084013590820152828201358183015290517fa27a43895875369be7ca68bfe853b87f531a2fd742a2d699a603684d920b05309181900360600190a16100d534156008610141565b60408051818301356020820152610109910160408051601f1981840301815291905280516020909101208235146009610141565b6040513390602083013580156108fc02916000818181858888f19350505050158015610139573d6000803e3d6000fd5b506000805533ff5b816101665760405163100960cb60e01b81526004810182905260240160405180910390fd5b5050565b60006060828403121561017c57600080fd5b50919050565b828152606081016101a0602083018480358252602090810135910152565b939250505056fea2646970667358221220ef114d105b849fe3009f04b06ca0f4805c50d328d43315142597d6e257d09d6d64736f6c63430008050033`,
  BytecodeLen: 987,
  Which: `oD`,
  deployMode: `DM_firstMsg`,
  version: 1,
  views: {
    }
  };

export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };

